export interface BuylistItem {
  buylistID: number;
  cardBlueprintId: number;
  maxQuantity: number;
  buyPrice: number;
  buylistStoreCreditPrice: number;
  foil: boolean;
  blueprintName: string;
  blueprintVersion: string;
  expansionName: string;
  image_url: string;
  csvAntall?: number;
  quantity?: number; // User-selected quantity for selling
}

export interface BuylistCartItem {
  item: BuylistItem;
  quantity: number;
}

export enum BuylistPaymentMethod {
  KONTO = 'KONTO',
  STORE_CREDIT = 'STORE_CREDIT'
}

export interface BuylistOrderItem {
  buylistId: number;
  quantity: number;
}

export interface BuylistOrder {
  items: BuylistOrderItem[];
  totalAmount: number;
  paymentMethod: BuylistPaymentMethod;
  accountToPayTo?: string; // Account number for KONTO
  // Contact details (required for guest, optional for authenticated)
  firstName?: string;
  lastName?: string;
  email?: string;
  gateadresse?: string;
  postnummer?: string;
  poststed?: string;
}

export interface BuylistFilters {
  reservedList: boolean;
  gameChanger: boolean;
  topCommander: boolean;
  topEdhCard: boolean;
  premodernStaple: boolean;
  modernStaple: boolean;
}

// Response from GET /buylist/price-range (maps to backend PrisIntervallTO)
export interface PriceRangeResponse {
  minPris: number;
  maxPris: number;
}

// User-set price filter values (undefined = no filter applied)
export interface PriceFilter {
  minPrice?: number;
  maxPrice?: number;
}

// Order history status enum matching backend BuyOrderStatusEnum
export enum BuyOrderStatus {
  AAPNET = 'AAPNET',
  FERDIG = 'FERDIG',
  SENDT = 'SENDT',
  SENDT_MAIL = 'SENDT_MAIL',
  BETALT = 'BETALT',
  STORE_CREDIT_BETALT = 'STORE_CREDIT_BETALT',
  KANSELLERT = 'KANSELLERT',
  FERDIG_GRADERT = 'FERDIG_GRADERT',
}

// Individual card item in an order history entry
export interface BuyOrderItemHistorikk {
  kortNavn: string;
  versjon: string;
  ekspansjon: string;
  foil: boolean;
  tilstand: string;
  pris: number;
}

// Order history entry from GET /kunde/ordrehistorikk
export interface BuyOrderHistorikk {
  ordreReferanse: string;
  status: BuyOrderStatus;
  dato: string | null;
  totalsum: number;
  betalingsmetode: BuylistPaymentMethod;
  antallKort: number;
  kort: BuyOrderItemHistorikk[];
}
